import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

interface CoinGeckoPriceInfo {
  btc: number;
  eth: number;
  usd: number;
  cny: number;
}
export interface CoinGeckoPriceJson {
  bitcoin?: CoinGeckoPriceInfo;
  ethereum?: CoinGeckoPriceInfo;
}
/**
 * useCoinGeckoPriceSWR
 */
export default function useCoinGeckoPriceSWR() {
  return useSWR(
    '/api/v1/coingecko/price',
    async url =>
      request.post<ResponseObject<CoinGeckoPriceJson>>(url, null, {
        baseURL: '',
      }),
    {
      refreshInterval: 3600_000,
      keepPreviousData: true,
    }
  );
}
